import angular from 'angular';

import tszProgressBar from './tsz-progress-bar';

const tszProgressBarModule = angular.module('tsz.components.tszProgressBar', [])
  .component('tszProgressBar', tszProgressBar);

export default tszProgressBarModule;



// WEBPACK FOOTER //
// ./src/components/tsz-progress-bar/tsz-progress-bar.module.js